import React, { Component } from 'react';
import _ from 'underscore';
import ga from 'analytics';

import Utils from 'utils/Utils.js';
import SurveyPageMCQ from './SurveyPageMCQ.js';


class SurveyPageMCQContainer extends Component {
    constructor(props) {
        super(props);
        this.initialState = {answerKeys:[],valid:false};
        this.state = this.props.savedState || this.initialState;
        if(!this.props.savedState) {
            this.state = this.applyDefaultValues();
            this.state = this.applyPersistedState();
        }
        this.onSubmit = this.onSubmit.bind(this);
        this.isActive = this.isActive.bind(this);
        this.onRefresh = this.onRefresh.bind(this);
    }
    componentWillMount() {
        ga('send', 'pageview', { 'page': (this.props.virtualURL || '/virtual/survey-page-mcq') }); 
    }
    getChallengeAnswersByKey() {
        return this.props.surveyPage.challenge.challengeAnswers.reduce((m,item)=>{
                                        m[item.key] = item;
                                        return m;
                                    },{});
    }
    applyDefaultValues() {
        var challengeAnswers = this.props.surveyPage.challenge.challengeAnswers;
        var answerKeys = challengeAnswers.filter(ca => (ca.data==='true' || ca.data===true)).map(ca => ca.key);
        return {...this.state, answerKeys};
    }
    applyPersistedState() {
        var userChallengeAnswers = Utils.deref(this.props.surveyPage, 'challenge.userChallenge.userChallengeAnswers', null);
        var challengeAnswersByKey = this.getChallengeAnswersByKey();
        if(userChallengeAnswers) {
            var answerKeys = userChallengeAnswers.map(uca => uca.key).filter(key => challengeAnswersByKey.hasOwnProperty(key));
            return {...this.state, answerKeys};
        }
        return this.state;
    }
    onSubmit(event, ca) {
        event.preventDefault();
        this.setState((prevState)=>{
            return {answerKeys:[ca.key]}
        },
        ()=>{
            var challengeAnswersByKey = this.getChallengeAnswersByKey();
            var challengeAnswers = this.state.answerKeys.map(key => challengeAnswersByKey[key]);
            this.props.onSubmit(null,{challengeId:this.props.surveyPage.challenge.id, challengeAnswers:challengeAnswers}, this.state);
        });
    }
    isActive(ca) {
        return (this.state.answerKeys.indexOf(ca.key))>=0;
    }
    onRefresh() {
        this.props.onRefresh().then(()=>this.setState(this.initialState));
    }
    render() {
        return <SurveyPageMCQ
                   surveyPage={this.props.surveyPage}
                   inlineButtons={this.props.inlineButtons}
                   pageNum={this.props.pageNum}
                   numPages={this.props.numPages}
                   onSkip={this.props.onSkip}
                   value={this.state.value}
                   onSubmit={this.onSubmit}
                   isActive={this.isActive}
                   canRefresh={this.props.canRefresh}
                   noPageNumbers={this.props.noPageNumbers}
                   onRefresh={this.props.onRefresh ? this.onRefresh : null}
                   />;
    }

}

export default SurveyPageMCQContainer;



// WEBPACK FOOTER //
// ./src/modules/surveys/types/SurveyPageMCQContainer.js